import { Footer } from '@ethena/shared-ui/src/components/Footer'
import { GITHUB_URL, TWITTER_URL } from '@ethena/shared-ui/src/constants/url'

import { routes } from '@/components/global-container'
import { IS_GERMAN } from '@/constants'

export const LandingFooter = () => {
  const socials = [
    {
      alt: 'Twitter',
      href: TWITTER_URL,
      icon: '/x.svg',
    },
    {
      alt: 'Github',
      href: GITHUB_URL,
      icon: '/github.svg',
    },
  ]

  return (
    <Footer
      routes={IS_GERMAN ? [] : routes}
      socials={IS_GERMAN ? [] : socials}
      className="landing-section lg:!pt-0 !pb-[80px] lg:!pb-6 lg:hlg:!pb-[80px] z-10"
      maxWidth="landing-layout"
    />
  )
}
